module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/REV_contents"
    }
  }, [_vm._v("Chief abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "roman"
  }, [_vm._v("AG")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Greek–English Lexicon of the New Testament and Other Early Christian Literature ")]), _vm._v("by William F. Arndt and F. Wilbur Gingrich (University of Chicago Press and Cambridge University Press, 1957).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("av")]), _vm._v(" – "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Authorized ")]), _vm._v("(King James) "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("Version ")]), _vm._v("of the Bible (1611).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Caird – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of St John the Divine")]), _vm._v(" by G. B. Caird (A. and C. Black, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Farrer – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of St John the Divine")]), _vm._v(" by Austin Farrer (Oxford University Press, 1964).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Glasson – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of John")]), _vm._v(" by T. F. Glasson ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Cambridge Bible Commentary on the New English Bible")]), _vm._v(", Cambridge University Press, 1965).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("jb")]), _vm._v(" – "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Jerusalem Bible ")]), _vm._v("(Darton, Longman and Todd, 1966).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("jbp")]), _vm._v(" – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament in Modern English")]), _vm._v(" by J. B. Phillips (Collins, 1958).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Kiddle – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of St John")]), _vm._v(" by Martin Kiddle ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Moffatt New Testament Commentary")]), _vm._v(", Hodder and Stoughton, 1940).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Knox – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The New Testament of our Lord and Saviour Jesus Christ")]), _vm._v(" translated by Ronald Knox (Burns, Oates and Washbourne, 1946).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Maycock – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Apocalypse")]), _vm._v(" by A. L. Maycock (Dacre Press, n.d.).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Morris – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of St John")]), _vm._v(" by Leon Morris ("), _c('span', {
    staticClass: "roman"
  }, [_vm._v("Tyndale New Testament Commentaries")]), _vm._v(", Inter-Varsity Press, 1969).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("neb")]), _vm._v(" – "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The New English Bible ")]), _vm._v("(New Testament, 1961; Old Testament, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("nrsv – ")]), _vm._v("The New Revised Standard Version of the Bible (1989, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("rsv")]), _vm._v(" – "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Revised Standard Version")]), _vm._v(" of the Bible (New Testament, 1946; Old Testament, 1952; revised edition, 1995).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("rv")]), _vm._v(" – "), _c('span', {
    staticClass: "roman"
  }, [_vm._v("The Revised Version ")]), _vm._v("of the Bible (1885).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Swete – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Apocalypse of St John")]), _vm._v(" by H. B. Swete (Macmillan, third edition, 1911).")]), _vm._v(" "), _c('p', {
    staticClass: "abb_fo"
  }, [_vm._v("Walvoord – "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Revelation of Jesus Christ")]), _vm._v(" by John F. Walvoord (Marshall, Morgan and Scott, 1966).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-079ba644","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/REV_abbrev.vue
// module id = 75
// module chunks = 0